/**
 * Контекст перевода объяснений для компонентов.
 *
 * Разбор кодов живёт в чистом модуле `explanations.ts` и переводчика не знает.
 * Хук — единственный мост между ним и React: он же гарантирует, что валюта и
 * локаль во всех блоках подбора одинаковые.
 */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { ExplanationContext } from './explanations';

/** Валюта MVP одна (EUR), но берётся из данных автомобиля, а не из константы. */
export function useExplanationContext(currency = 'EUR'): ExplanationContext {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage ?? 'de';

  return useMemo<ExplanationContext>(
    () => ({
      t: (key, params) => t(key, params ?? {}),
      exists: (key) => i18n.exists(key),
      locale,
      currency,
    }),
    [t, i18n, locale, currency],
  );
}
